import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const StatBoxElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Stat Box',
  icon: 'DocumentTextIcon',
  description: 'Adds a stat box',
  properties: [
    'layout',
    {
      label: 'Editable',
      name: 'editable',
      default: false,
      type: 'boolean',
      description:
        'If true, the stat can be edited. This should be used only in a data entry screen',
      editor: 'switch',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Format as Minutes',
      name: 'formatAsMinutes',
      default: false,
      type: 'boolean',
      description:
        'If true, the value of the stat entry is formatted into minutes. If value is less than 60 then seconds is displayed in the subtitle',
      editor: 'switch',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'editable',
          operator: '==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Stat Definition',
      name: 'statId',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description: 'The stat definition to use for this element',
      default: '',
      options: [],
      function: {
        name: 'getContentTypeStats',
        params: ['app.id', 'datasourceId']
      },
      displayWhen: [
        {
          field: 'editable',
          operator: '=',
          value: false
        }
      ]
    },
    {
      label: 'Collection Path',
      name: 'collectionPath',
      editor: 'textbox',
      description:
        'The path to the collection where this input field lives. This can include placeholders such as ${client.id}',
      default: '',
      displayWhen: [
        {
          field: 'editable',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Time Period',
      name: 'timePeriod',
      editor: 'dropdown',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
      description:
        'If this stat is Time Agreegated, which time period do you want to display as the value?',
      default: 'today',
      options: [
        { label: '<Not Set>', value: '' },
        { label: 'All Time', value: 'alltime' },
        { label: 'Today', value: 'today' },
        { label: 'This Week', value: 'week' },
        { label: 'This Month', value: 'month' },
        { label: 'This Year', value: 'year' }
      ],
      displayWhen: [
        {
          field: 'editable',
          operator: '=',
          value: false
        }
      ]
    },
    {
      label: 'Title',
      name: 'title',
      editor: 'textbox',
      description: 'The main title of the stat box',
      default: 'Calories',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title Padding',
      name: 'titlePadding',
      editor: 'boundary',
      description: 'Padding around the title',
      default: '0 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title',
      name: 'subtitle',
      editor: 'textbox',
      description:
        'The sub-title of the stat box that appears below the value. Usually the units of measurement. i.e kCal, steps etc',
      default: 'sub-title',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Sub-Title Padding',
      name: 'subtitlePadding',
      editor: 'boundary',
      description: 'Padding around the sub-title',
      default: '5 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Secondary Sub-Title',
      name: 'secondarySubtitle',
      editor: 'textbox',
      description:
        'The secondary sub-title of the stat box that appears below the value. Usually the units of measurement. i.e kCal, steps etc',
      default: 'sub-title',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Secondary Sub-Title Padding',
      name: 'secondarySubtitlePadding',
      editor: 'boundary',
      description: 'Padding around the second sub-title',
      default: '5 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Font',
      name: 'titleFont',
      type: 'font',
      editor: 'fontsize',
      description: 'The font of the title text',
      default: 24,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Sub-Title Font',
      name: 'subtitleFont',
      type: 'font',
      editor: 'fontsize',
      description: 'The font of the sub-title text',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Secondary Sub-Title Font',
      name: 'secondarySubtitleFont',
      type: 'font',
      editor: 'fontsize',
      description: 'The font of the secondary sub-title text',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Value Font',
      name: 'valueFont',
      type: 'font',
      editor: 'fontsize',
      description: 'The font of the stat box value',
      default: 24,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Value Padding',
      name: 'valuePadding',
      editor: 'boundary',
      description: 'Padding around the value',
      default: '10 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Color',
      name: 'titleColor',
      editor: 'color',
      description: 'The color of the title text',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Sub-Title Color',
      name: 'subtitleColor',
      editor: 'color',
      description: 'The color of the sub-title text',
      default: '#B8B8B8',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Secondary Sub-Title Color',
      name: 'secondarySubtitleColor',
      editor: 'color',
      description: 'The color of the secondary sub-title text',
      default: '#B8B8B8',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Value Color',
      name: 'valueColor',
      editor: 'color',
      description: 'The color of the stat box value',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Icon Color',
      name: 'iconColor',
      editor: 'color',
      description: 'The color of the stat box icon',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      editor: 'color',
      description: 'The background color of the stat box',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Icon',
      name: 'icon',
      editor: 'icon',
      description:
        'The icon that will be used in the top right of the stat box',
      default: 'InformationCircleIcon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Confirm Edit Icon',
      name: 'iconConfirm',
      editor: 'icon',
      description: 'The icon that will be when the stat box is in edit mode',
      default: 'CheckIcon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    'iconsize',
    {
      name: 'width',
      label: 'Width',
      description: '',
      editor: 'number',
      type: 'string',
      default: 140,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'height',
      label: 'Height',
      description: '',
      editor: 'number',
      type: 'string',
      default: 120,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the iamge',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius',
      name: 'borderRadius',
      editor: 'number',
      description: 'The border radius of the image',
      default: 5,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the image',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Style',
      name: 'borderStyle',
      editor: 'dropdown',
      description: 'The border style of the image',
      default: 'solid',
      options: [
        { label: 'Solid', value: 'solid' },
        { label: 'Dotted', value: 'dotted' },
        { label: 'Dashed', value: 'dashed' }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    'alignment',
    {
      name: 'margin',
      label: 'Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 0 10 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'padding',
      label: 'Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default StatBoxElementFields;
